<script>
  // import VerticalNavBox from '@components/List/VerticalNavBox'

  export default {
    components: {
      // VerticalNavBox,
    },
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        },
      },
    },
    computed: {},
    methods: {
      imgErrorSrc(item) {
        item.icon = require('@src/assets/images/home/productCategory/icon1.svg');
        // return require(`@src/assets/images/home/productCategory/icon1.svg`)
      },
      goToView(alias) {
        this.$router.push({
          name: 'product-list', query: { filterCategory: alias }
        })
      }
    }
  }
</script>

<template>
  <div class="section" :class="$style.sectionProducts">
    <div class="container">
      <div class="sectionProducts__box">
        <h2 class="Home-title"
        ><span class="Home-title__small">專業技術支援</span>
          <span class="Home-title__big pb-4">零壹代理產品</span>
        </h2>
        <div class="row sectionProducts__list">
          <div
            v-for="(item,$index) in list"
            :key="$index"
            class="sectionProducts__item text-center"
          >
            <div class="sectionProducts__item__box" @click="goToView(item.alias)">
              <div class="sectionProducts__item__boxInner">
                <img
                  :src="item.image ? item.image : require(`@src/assets/images/home/productCategory/iconDefault.svg`)"
                  class="icon"
                  alt=""
                  @error="require(`@src/assets/images/home/productCategory/iconDefault.svg`)"
                >
                <p class="pt-3 title">{{ item.title }}</p>
                <div class="text-white view">查看代理產品</div>
              </div>
            </div>
          </div>
          <router-link
            :to="{ name: 'product-list' }"
            class="sectionProducts__item viewAll text-center"
          >
            <div class="sectionProducts__item__box">
              <!-- <img 
              :src="require(`@src/assets/images/home/productCategory/${item.icon}`)" 
                alt=""
                @error="imgErrorSrc(item)"
              > -->
              <div class="sectionProducts__item__boxInner">
                <i class="fal fa-plus-circle text-2xl icon"></i>
                <p class="pt-3 title">所有產品</p>
              </div>
            </div>
          </router-link>
        </div>
        <!-- <VerticalNavBox :list="list" is-home-products />
        <div class="text-center">
          <BaseButton
            class="isStylePrimary isRadius isCol4"
            :to="{ name: 'product-list' }"
          >
            探索所有產品
          </BaseButton>
        </div> -->
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
  .sectionProducts {

    :global {
      .sectionProducts {
        &__list {
          margin-top: -40px;
          margin-right: -26px;
          margin-left: -26px;

          @media screen and (max-width: 1200px) {
            margin-right: -19px;
            margin-left: -19px;
          }

          @include max-sm {
            margin-right: 0;
            margin-left: 0;
          }
        }

        &__item {
          -webkit-box-flex: 0;
          -ms-flex: 0 0 20%;
          flex: 0 0 20%;
          max-width: 20%;
          padding-right: 26px;
          padding-left: 26px;
          margin-top: 40px;

          @media screen and (max-width: 1200px) {
            -ms-flex: 0 0 25%;
            flex: 0 0 25%;
            max-width: 25%;
            padding-right: 19px;
            padding-left: 19px;
            -webkit-box-flex: 0;
          }

          @include max-lg {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 33.33333%;
            flex: 0 0 33.33333%;
            max-width: 33.33333%;
          }

          @include max-md {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 50%;
            flex: 0 0 50%;
            max-width: 50%;
            padding-right: 9px;
            padding-left: 9px;
          }

          &__box {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            padding-top: 100%;
            overflow: hidden;
            cursor: pointer;
            cursor: pointer;
            border: 1px solid $color-gray-2;
            border-radius: 2px;
            // transition: .3s;
            transition: background 0.4s;
            &:hover {
              background: $color-primary;

              &::before {
                height: 100%;
                // top:0;
              }

              .icon {
              }

              .title {
                color: #FFF;
                transform: translateY(-50px);

                @include max-sm {
                  transform: translateY(-30px);
                }
              }

              .view {
                transform: translate(-50%, -90px);
              }
            }
          }

          &__boxInner {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 100%;
            text-align: center;
            text-indent: 0.25em;
            transform: translate(-50%, -50%);

            .title {
              margin-bottom: 0;
              font-size: 1.25rem;
              font-weight: medium;
              color: $color-gray-6;
              transition: transform .3s, color .1s;
              transform: translateY(0);

              @include max-sm {
                font-size: 1rem;
              }
            }

            .icon {
              @include max-sm {
                width: 50px;
              }
            }

            .view {
                padding: 1rem;
                font-weight: medium;
                border: 1px solid #fff;
                border-radius: 2px;
                position: absolute;
                bottom: -120px;
                margin: 0 auto !important;
                transform: translateX(-50%);
                left: 50%;
                transition: transform .3s;
                white-space: nowrap;

              @include max-sm {
                padding: .5rem;
                font-size: 0.875rem;
              }
            }
          }

          &.viewAll {
            .sectionProducts__item__box {
              background: $color-primary;
              transition: .3s;

              &:hover {
                background: $color-primary-hover
              }
            }

            .title {
              color: #FFF;
              transform: none;
            }

            .icon {
              font-size: 52px;
              color: #FFF;

              @include max-sm {
                font-size: 42px;
              }
            }
          }
        }
      }
    }
  }
</style>
